import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Search } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import AlertPopup from "./components/AlertPopup";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Helmet } from "react-helmet";
import { withStyles } from "@material-ui/core/styles";
import { push } from "connected-react-router";
import homeData from "config/mockup/home";
import { gameAll } from "actions/Game";
import { setNavigateParams } from "actions/Navigate";
import { getLoggedGamesFromStorage } from "util/Common";

const styles = () => ({
  searchItem: {
    "&:hover": {
      backgroundColor: "#e484861f",
    },
  },
});

class HomePage extends React.Component {
  constructor() {
    super();
    this.state = this.initialState;
    this.wrapperRef = React.createRef();
  }

  get initialState() {
    return {
      email: "demo@example.com",
      password: "demo#123",
      listData: homeData,
      searchValue: "",
      lazyLoading: false,
      quantity: 18,
      mode: "all",
      mouseIn: false,
      loginSave: [],
      keyError: null,
    };
  }

  componentDidMount() {
    this.props.gameAll();
    document.addEventListener("scroll", this.trackScrolling);
    document.addEventListener("click", this.handleClickOutside);
  }

  autoAlias(str, between = " ") {
    if (!str) {
      return null;
    }
    str += "";
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(
      /!|@|\$|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|'|"|&|#|\[|\]|~/g,
      between
    );
    str = str.replace(/-+-/g, between);
    str = str.replace(/^-+|-+$/g, between);
    return str;
  }

  isExistWord(value, query) {
    let valueAlias = this.autoAlias(value);
    let queryAlias = this.autoAlias(query);
    if (valueAlias.includes(queryAlias)) {
      return value;
    }
  }

  handleChange = (event) => {
    const { gameNames } = this.props;
    let searchList = gameNames.filter((element) => {
      if (
        element.shopfrontName &&
        this.isExistWord(element.shopfrontName, event.target.value)
      ) {
        return this.isExistWord(element.shopfrontName, event.target.value);
      }
    });

    this.setState({
      searchList: searchList,
      searchValue: event.target.value,
    });
  };

  handleChangeMode = (mode) => {
    this.setState({ mode, quantity: 18 });
  };

  loadMore = () => {
    const { quantity, lazyLoading, mode } = this.state;
    const { games, mobileGames, desktopGames } = this.props;

    switch (mode) {
      case "mobile":
        if (quantity < mobileGames.length && lazyLoading)
          this.setState({ quantity: quantity + 9, lazyLoading: false });
        break;
      case "pc":
        if (quantity < desktopGames.length && lazyLoading)
          this.setState({ quantity: quantity + 9, lazyLoading: false });
        break;
      default:
        if (quantity < games.length && lazyLoading)
          this.setState({ quantity: quantity + 9, lazyLoading: false });
        break;
    }
  };

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight + 50;
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.trackScrolling);
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleFocus);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ mouseIn: true });
    } else {
      this.setState({ mouseIn: false });
    }
  };

  trackScrolling = () => {
    const { quantity, mode } = this.state;
    const { games, mobileGames, desktopGames } = this.props;

    const wrappedElement = document.getElementById("homePage");
    if (this.isBottom(wrappedElement)) {
      switch (mode) {
        case "mobile":
          if (quantity < mobileGames.length)
            this.setState({ lazyLoading: true });
          break;
        case "pc":
          if (quantity < desktopGames.length)
            this.setState({ lazyLoading: true });
          break;
        default:
          if (quantity < games.length) this.setState({ lazyLoading: true });
          break;
      }

      setTimeout(() => {
        this.loadMore();
      }, 300);
    }
    //this.loadMore();
  };

  handleParams = (shopfrontID) => (e) => {
    e.preventDefault();
    const { push, setNavigateParams } = this.props;

    const appIds = getLoggedGamesFromStorage();

    const idx = appIds.map((e) => e.gameID).indexOf(shopfrontID);

    setNavigateParams({
      gameID: shopfrontID,
    });

    if (idx !== -1) {
      setNavigateParams({
        userID: appIds[idx].userID,
      });
      push(`/app/all-info?gameID=${shopfrontID}&userID=${appIds[idx].userID}`);
    } else {
      push(`/login?gameID=${shopfrontID}`);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      keyError: new Date().getTime(),
    });
  };

  render() {
    const {
      searchValue,
      lazyLoading,
      quantity,
      searchList,
      mode,
      mouseIn,
      keyError,
    } = this.state;
    const { games, mobileGames, desktopGames, classes } = this.props;
    const appIds = getLoggedGamesFromStorage();
    let arrayGame = [];

    switch (mode) {
      case "mobile":
        arrayGame = mobileGames;
        break;
      case "desktop":
        arrayGame = desktopGames;
        break;
      default:
        arrayGame = games;
        break;
    }

    return (
      <div id="homePage" className="homePage">
        <Helmet>
          <title>Trang chủ</title>
        </Helmet>
        <div className="alert-popup-container">
          {keyError ? <AlertPopup key={keyError} /> : <></>}
        </div>
        {/* alert-popup-container */}
        <div
          className="banner"
          style={{
            backgroundImage: `url(
              https://pay.zing.vn/static/img/tet_search_banner.jpg
            )`,
          }}
        >
          <div className="searchGame">
            <h1>Thông tin người dùng</h1>
            <form
              action=""
              className="form-search"
              ref={this.wrapperRef}
              onSubmit={this.handleSubmit}
            >
              <Search />
              <input
                type="text"
                value={searchValue}
                placeholder="Tìm game..."
                onChange={(event) => this.handleChange(event)}
              />
              <div
                className="list-group position-absolute w-100 searchGame-box"
                style={
                  mouseIn
                    ? {
                        zIndex: 99,
                        backgroundColor: "#fff",
                        transform: "scale(1, 0)",
                        transformOrigin: "center top",
                        transition: ".3s all linear",
                      }
                    : {
                        zIndex: 99,
                        backgroundColor: "#fff",
                        transform: "scale(1, 1)",
                        transformOrigin: "center top",
                        transition: ".3s all linear",
                      }
                }
              >
                {searchList && searchList.length
                  ? searchList.map((item, index) => (
                      <Link
                        key={`${item.shopfrontID}-${index}`}
                        href="javascript:void(0)"
                        title="Đăng nhập"
                        className={`list-group-item list-group-item-action text-left ${classes.searchItem}`}
                        onClick={this.handleParams(item.shopfrontID)}
                      >
                        <div className="d-flex ">
                          <span className="w-100">{item.shopfrontName}</span>
                          <span className="flex-shrink-1">
                            {item.platform === "pc" ? "PC" : "Mobile"}
                          </span>
                        </div>
                      </Link>
                    ))
                  : ""}
              </div>
            </form>
          </div>
        </div>
        <div className="zid-container">
          <div className="filter">
            <h3>Danh sách game</h3>
          </div>
          <div className="list-game">
            <Grid container spacing={3}>
              {arrayGame.length
                ? arrayGame.slice(0, quantity).map((item, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      key={`${item.shopfrontID}-${index}`}
                    >
                      <div className="list-item">
                        <h3>{item.shopfrontName}</h3>
                        <div
                          className="thumbnail"
                          style={{
                            backgroundImage: `url(${item.images.appBanner})`,
                          }}
                        >
                          {/* <img src={item.images.appBanner} alt="" /> */}
                        </div>
                        <Link
                          href="javascript:void(0)"
                          title={
                            appIds
                              .map((e) => e.gameID)
                              .indexOf(item.shopfrontID) !== -1
                              ? "Cập nhật"
                              : "Đăng nhập"
                          }
                          onClick={this.handleParams(item.shopfrontID)}
                        >
                          {appIds
                            .map((e) => e.gameID)
                            .indexOf(item.shopfrontID) !== -1
                            ? "Cập nhật"
                            : "Đăng nhập"}
                        </Link>
                      </div>
                    </Grid>
                  ))
                : ""}
              {lazyLoading ? (
                <div className="text-center w-100">
                  <CircularProgress />
                </div>
              ) : (
                ""
              )}
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, game }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  const { games, gameNames, mobileGames, desktopGames } = game;
  return {
    loader,
    alertMessage,
    showMessage,
    authUser,
    games,
    gameNames,
    mobileGames,
    desktopGames,
  };
};

export default connect(mapStateToProps, {
  gameAll,
  push,
  setNavigateParams,
})(withStyles(styles)(HomePage));
